import React from 'react'
import moment from 'moment-mini'
import { Reservation } from '../../types/reservation'
import './vehicleCard.less'
import { ports } from '../SeaWayBill'

const fullDateFormat = (date: number) => moment(date).format('DD.MM.YYYY HH:mm')

interface Props {
  reservation: Reservation
}

const VehicleCard: React.FC<Props> = ({ reservation }: Props) => {
  const totalWeight = reservation.cargoUnit.cargoWeight + reservation.cargoUnit.weight
  const notes = reservation.notes.filter((n) => n.vouch && n.vouch.checked).map((n) => n.note)
  const note1 = notes[0] ? notes[0] : ''
  const note2 = notes[1] ? notes[1] : ''
  const note3 = notes[2] ? notes[2] : ''
  return (
    <div className="vehicleCard">
      <div className="inner">
        <div className="container">
          <div className="left-side vertical-text">Vehicle</div>
          <div className="right-side vertical-text">{reservation.drivers.length === 2 ? '2 DRIVERS' : '1 DRIVER'}</div>
          <div className="block">
            <div className="ship bold">{reservation.route.ship}</div>
            <div className="card-name">Vehicle Boarding Card</div>
            <div className="row">
              <div>
                {ports[reservation.route.portFrom]}-{ports[reservation.route.portTo]}
              </div>
              &nbsp;&nbsp;
              <div>{fullDateFormat(reservation.route.dateFrom)}</div>
            </div>
          </div>
          <div className="block notes">
            <div>{note1}</div>
            {!note1 && <br />}
            <div>{note2}</div>
            {!note2 && <br />}
            <div>{note3}</div>
          </div>
          <div className="block">
            <div className="row regNumber">
              <div>{reservation.cargoUnit.regNumber}</div>
              <div>&nbsp;+&nbsp;</div>
              <div>{reservation.cargoUnit.trailerRegNumber}</div>
            </div>
            <div>{reservation.cargoType}</div>
            <br />
            <div className="row">
              <div>Weight:&nbsp;{totalWeight}&nbsp;kg</div>
              {reservation.cargoUnit.length && <div>,&nbsp;Length:&nbsp;{reservation.cargoUnit.length}&nbsp;m</div>}
            </div>
          </div>
          <div className="block">
            <div>RES&nbsp;ID:&nbsp;{reservation.resId}</div>
          </div>
        </div>
        <div className="page-break" />
      </div>
    </div>
  )
}

export default VehicleCard
